import React from 'react';
import NoticeType from './NoticeType';
import { Container } from 'react-bootstrap';
const Tenders = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return (
        <Container className='py-3 py-md-5'>
            <NoticeType ntId={1} spId={234} cardHeading={appLanguage === 'hi' ? 'निविदाएँ' : 'TENDERS'} />
        </Container>
    );    
}
export default Tenders;